<template>
  <div>
    <div
      class="modal fade"
      id="settlementCheckoutDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">×</button>
            <h4 class="modal-title">
              <b>{{ lang.SET100 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <component
              ref="checkoutComponent"
              :is="checkoutComponents[currentStep].component"
              :data="checkoutComponents[currentStep].props"
            ></component>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ currentStep > 2 ? lang.SET118 : lang.SET101 }}
            </button>
            <button
              type="button"
              class="btn btn-raised btn-default"
              v-show="currentStep > 0 && currentStep < 3"
              @click="currentStep--, (editBankDetails = false)"
            >
              {{ lang.SET110 }}
            </button>
            <button
              type="button"
              class="btn btn-raised btn-success"
              :class="{ 'dialog-btn-primary': currentStep !== 2 }"
              v-show="currentStep < 3"
              :disabled="editBankDetails"
              @click="currentStep === 2 ? onFinishSettlement() : currentStep++"
            >
              {{ currentStep === 2 ? lang.SET103 : lang.SET102 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckOverview from "./CheckoutSteps/CheckOverview";
import BankDetails from "./CheckoutSteps/BankDetails";
import CompletionMessage from "./CheckoutSteps/CompletionMessage";
import BillingOverview from "./CheckoutSteps/BillingOverview";

export default {
  name: "SettlementCheckout",
  props: {
    showDialog: { type: Boolean, default: false },
    selectedSurveys: { type: Array, default: () => [] },
  },
  components: {
    CheckOverview,
    BankDetails,
    CompletionMessage,
    BillingOverview,
  },
  data() {
    return {
      currentStep: 0,
      shopperCart: {},
      shopperProfileData: {},
      shopperBankDetails: {},
      editBankDetails: false,
      isSmallScreen: false,
      checkoutGuid: "",
      lang: {
        SET100: "Invoice",
        SET101: "Cancel",
        SET102: "Next",
        SET103: "Confirm",
        SET104: "Bank details updated",
        SET105: "Bank details update failed",
        SET106: "Checks",
        SET107: "Bank Details",
        SET108: "Completion",
        SET109: "Billing Overview",
        SET110: "Previous",
        SET111: "Invoice submission failed",
        SET112: "Cart creation failed",
        SET113: "Adding cart content failed",
        SET114: "Cart request failed",
        SET115: "Cart deletion failed",
        SET116: "Bank details request failed",
        SET117: "Billing address request failed",
        SET118: "Close",
      },
    };
  },
  created() {
    this.globals.$off("getBankDetails");
    this.globals.$on("getBankDetails", () => {
      this.editBankDetails = false;
      this.getShopperBankDetails();
      this.getShopperProfileData();
    });

    this.globals.$off("saveShopperBankDetails");
    this.globals.$on("saveShopperBankDetails", (data) => {
      this.shopperBankDetails = data.BankDetails;
      this.shopperProfileData = data.ShopperProfileData;

      let requestCount = 2;
      let success = () => {
        if (--requestCount > 0) return;
        this.$refs.checkoutComponent.setSavedShopperBankDetails();
        this.globals.showSuccessSnackbar(this.lang.SET104);
      };
      let error = () => {
        this.globals.showErrorSnackbar(this.lang.SET105);
      };
      this.saveShopperBankDetails(success, error);
      this.saveShopperProfileData(success, error);
    });

    this.globals.$off("editBankDetails");
    this.globals.$on("editBankDetails", (editBankDetails) => {
      this.editBankDetails = editBankDetails;
    });
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#settlementCheckoutDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    // Sets the new table height after the window got resized
    let resizeFunc = () => {
      this.isSmallScreen = this.globals.isSmallScreen();
      this.$forceUpdate();
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();
  },
  computed: {
    checkoutComponents() {
      // components in the series of their appearance
      return [
        {
          name: this.lang.SET106,
          component: "CheckOverview",
          props: this.shopperCart,
        },
        {
          name: this.lang.SET107,
          component: "BankDetails",
          props: {
            BankDetails: this.shopperBankDetails,
            ShopperProfileData: this.shopperProfileData,
          },
        },
        {
          name: this.lang.SET109,
          component: "BillingOverview",
          props: {
            ShopperCart: this.shopperCart,
            BankDetails: this.shopperBankDetails,
            ShopperProfileData: this.shopperProfileData,
          },
        },
        {
          name: this.lang.SET108,
          component: "CompletionMessage",
        },
      ];
    },
  },
  watch: {
    showDialog(newValue) {
      newValue
        ? this.openSettlementCheckoutDialog()
        : this.closeSettlementCheckoutDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    currentStep(newValue, oldValue) {
      if (this.globals.isMobileBrowser || !this.globals.isLargeScreen()) return;
      if (newValue === 2)
        $("#settlementCheckoutDialog .modal-dialog").css("width", "1100px");
      else if (oldValue === 2)
        $("#settlementCheckoutDialog .modal-dialog").css("width", "");
    },
  },
  methods: {
    openSettlementCheckoutDialog() {
      this.initSettlementCheckoutDialog();
    },
    closeSettlementCheckoutDialog() {
      if (this.checkoutGuid) this.$emit("dialogDataSaved");
      $("#settlementCheckoutDialog").modal("hide");
    },
    initSettlementCheckoutDialog() {
      this.currentStep = 0;
      this.editBankDetails = false;
      this.checkoutGuid = "";
      this.getShopperBankDetails();
      this.getShopperProfileData();
      this.deleteAllCarts(true);
    },
    onFinishSettlement() {
      let payload = {
        CartGuid: this.shopperCart.CartGuid,
        BankDetailsGuid: this.shopperBankDetails.BankDetailsGuid,
      };
      let queryString = "/shopper-api/Checkout";

      $.ajax({
        method: "POST",
        url: queryString,
        data: JSON.stringify(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.checkoutGuid = data.CheckoutGuid;
          this.currentStep++;
        },
        error: () => {
          console.error("Error on POST in onFinishSettlement()");
          this.globals.showErrorSnackbar(this.lang.SET111);
        },
      });
    },
    createEmptyCart() {
      let queryString = "/shopper-api/Cart";

      $.ajax({
        method: "POST",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            this.$emit("dialogClosed");
            return;
          }

          this.shopperCart.CartGuid = data.CartGuid;
          this.addSurveyInstancesToCart();
        },
        error: () => {
          console.error("Error on POST in createEmptyCart()");
          this.globals.showErrorSnackbar(this.lang.SET112);
        },
      });
    },
    addSurveyInstancesToCart() {
      let payload = this.selectedSurveys.map((selectedSurvey) => ({
        SurveyInstanceGuid: selectedSurvey,
      }));
      let queryString = `/shopper-api/Cart/${this.shopperCart.CartGuid}/Items`;

      $.ajax({
        method: "POST",
        url: queryString,
        data: JSON.stringify(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            this.$emit("dialogClosed");
            return;
          }

          this.getShopperCart(true);
          $("#settlementCheckoutDialog").modal("show");
        },
        error: () => {
          console.error("Error on POST in addSurveyInstancesToCart()");
          this.globals.showErrorSnackbar(this.lang.SET113);
        },
      });
    },
    getShopperCart(isCartEmpty) {
      let queryString = `/shopper-api/Cart`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!_.isEmpty(data)) {
            this.shopperCart = data;
            if (!isCartEmpty) this.deleteAllCarts(true);
          } else this.createEmptyCart();
        },
        error: () => {
          console.error("Error on GET in getShopperCart()");
          this.globals.showErrorSnackbar(this.lang.SET114);
        },
      });
    },
    deleteAllCarts(createNewCart) {
      $.ajax({
        method: "DELETE",
        url: `shopper-api/Cart`,
        success: () => {
          if (createNewCart) this.createEmptyCart();
        },
        error: () => {
          console.error("Error on DELETE in deleteAllCarts()");
          this.globals.showErrorSnackbar(this.lang.SET115);
        },
      });
    },
    getShopperBankDetails() {
      let queryString = `/shopper-api/Profile/BankDetails`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!_.isEmpty(data)) {
            this.shopperBankDetails = data[0];
          } else this.shopperBankDetails = {};
        },
        error: () => {
          console.error("Error on GET in getShopperBankDetails()");
          this.globals.showErrorSnackbar(this.lang.SET116);
        },
      });
    },
    saveShopperBankDetails(success, error) {
      let queryString = "shopper-api/Profile/BankDetails";
      let reqMethod = "POST";
      if (this.shopperBankDetails.BankDetailsGuid) {
        queryString += "/" + this.shopperBankDetails.BankDetailsGuid;
        reqMethod = "PUT";
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: JSON.stringify(this.shopperBankDetails),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (response) => {
          if (response && !_.isEmpty(response)) {
            this.shopperBankDetails = response;
          }
          if (success) success();
        },
        error: () => {
          console.error(`Error on ${reqMethod} in saveShopperBankDetails()`);
          if (error) error();
        },
      });
    },
    getShopperProfileData() {
      let queryString = `/shopper-api/Profile`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.shopperProfileData = data;
        },
        error: () => {
          console.error("Error on GET in getShopperProfileData()");
          this.globals.showErrorSnackbar(this.lang.SET117);
        },
      });
    },
    saveShopperProfileData(success, error) {
      let queryString = "shopper-api/Profile";

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.shopperProfileData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.getShopperCart(true);
          if (success) success();
        },
        error: () => {
          console.error("Error on PUT in saveShopperProfileData()");
          if (error) error();
        },
      });
    },
  },
};
</script>

<style scoped>
#settlementCheckoutDialog .modal-dialog {
  transition: all 200ms ease;
}
#settlementCheckoutDialog .modal-body {
  max-height: calc(100vh - 160px);
  overflow: auto;
}

@media (max-width: 1000px) {
  #settlementCheckoutDialog > .modal-dialog {
    width: 100vw;
    margin: 0;
    height: calc(100vh - 160px);
  }
  #settlementCheckoutDialog .modal-body {
    max-height: calc(100vh - 190px);
  }
  @media screen and (max-aspect-ratio: 13/9) {
    #settlementCheckoutDialog .modal-body {
      max-height: calc(100vh - 12em);
    }
  }
}
</style>



// WEBPACK FOOTER //
// SettlementCheckoutDialog.vue?489e066c